import React from 'react';
import './TagIcon.scss';

const TagIcon: React.FC = () => {
  return (
    <svg
      className="tag-icon"
      width="16"
      height="16"
      viewBox="0 0 10 10"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.178856 6.44211L3.56653 9.81736C3.67531 9.93344 3.82809 10 3.9878 10C4.14791 10 4.30029 9.93344 4.40948 9.81736L9.29033 4.92982C9.54253 4.66276 9.72342 4.33644 9.81631 3.9817C9.86642 3.65781 9.92468 3.18375 9.96624 2.82659C9.96624 2.82659 10.1333 0.923037 9.72423 0.515539C9.48223 0.27445 9.69938 0.482258 9.48223 0.27445C9.07359 -0.132235 7.1628 0.0333614 7.1628 0.0333614L6.00288 0.216816C5.8114 0.266333 5.62847 0.341014 5.45898 0.438423C5.31272 0.522845 5.17583 0.624314 5.05197 0.740394L0.178856 5.61088C0.0647793 5.71965 0 5.86983 0 6.02649C0 6.11335 0.0199634 6.19777 0.0570384 6.27408C0.0867799 6.33658 0.127929 6.3934 0.178856 6.44211ZM6.98721 1.70556C7.36855 1.54889 7.80652 1.63737 8.09742 1.92879C8.48732 2.32574 8.48732 2.96052 8.09742 3.35828C7.80652 3.6497 7.36855 3.73737 6.98721 3.5807C6.60586 3.42403 6.35734 3.05387 6.35734 2.64313C6.35734 2.41016 6.43719 2.19018 6.57612 2.01484C6.68205 1.8809 6.8222 1.77294 6.98721 1.70556Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TagIcon;
